import createDropdownContext from "@/providers/dropdown-provider/dropdown-provider";
import { DropdownSelectorOption } from "@/components/pages/home/components/searchbar/components/dropdown";
import { Filter } from "@/data/filters.constants";

export const {
  useDropdownContext: useGenderDropdownContext,
  DropdownProvider: GenderDropdownProvider,
} = createDropdownContext<Filter>();
